export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "org_invoice": {
            "invoice_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Factura"])},
            "amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monto total"])},
            "detraction_percent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Detracción (%)"])},
            "detraction_total": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Detracción"])},
            "exchange_rate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tipo de cambio"])},
            "container": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedor"])},
            "invoice_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de factura"])},
            "amount_paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monto pagado"])},
            "amount_balance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Balance"])},
            "paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagada"])},
            "currency": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Moneda"])},
            "receipt_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de recepción"])},
            "scheduled_payment_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de pago programado"])},
            "org_invoice_discounts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descuentos"])},
            "to_paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Por pagar"])},
            "fairtrade": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fairtrade"])},
            "fairtrade_incentive": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prima Fairtrade"])},
            "invoice_issuer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Emisor de factura"])},
            "week": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Semana"])},
            "harvested_batch": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lote"])}
          }
        }
      },
      "en": {
        "model": {
          "org_invoice": {
            "invoice_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invoice"])},
            "amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total amount"])},
            "detraction_percent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Detraction (%)"])},
            "detraction_total": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Detraction"])},
            "exchange_rate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exchange Rate"])},
            "container": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Container"])},
            "invoice_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invoice date"])},
            "amount_paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amount paid"])},
            "amount_balance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Balance"])},
            "paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paid"])},
            "currency": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Currency"])},
            "receipt_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Receipt date"])},
            "scheduled_payment_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scheduled payment date"])},
            "org_invoice_discounts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discounts"])},
            "to_paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To paid"])},
            "fairtrade": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fairtrade"])},
            "fairtrade_incentive": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fairtrade Premium"])},
            "invoice_issuer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invoice issuer"])}
          }
        }
      }
    }
  })
}